import React, { useState } from "react";
import "./Modal.css";
import { Button , Modal} from "react-bootstrap";
import { Trans } from 'react-i18next';





function Model({title ,body}) {
    const [show, setShow] = useState(false);
  
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    return (
      <> 
       <Trans >

        <Button className="btn1"  onClick={handleShow}>
           +       
          </Button>
  
        <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{body}</Modal.Body>
          <Modal.Footer>
            <Button className='btn2' variant="secondary" onClick={handleClose}>
              Close
            </Button>
            
          </Modal.Footer>
        </Modal>
       </Trans>
      </>
    );
  }
  
  export default Model;